const createAssetClientInterfaceWithCustomSigner = ({ assetClientInterface, signTransaction, }) => {
    return new Proxy(assetClientInterface, {
        get(target, property, receiver) {
            if (property === 'signTransaction') {
                return (...args) => signTransaction.apply(target, args);
            }
            const value = Reflect.get(target, property, receiver);
            if (value instanceof Function) {
                return (...args) => value.apply(target, args);
            }
            return value;
        },
    });
};
export default createAssetClientInterfaceWithCustomSigner;
